import Numeral from 'numeral'
import {
  add,
  percentage,
  sumBy,
  sumByIf,
  subtract,
} from './math.js'
import { billingType } from '../components/project-information/tab-content/tab-billing/constants'

export const getInvoicedBillingType = (billings, billingType = {}) => {
  const invoicedBillingType = billings.reduce((result, b) => {
    const { billing_types = [] } = b
    const invoicedType = sumByIf(billing_types, 'price', b => b.label === billingType.label)
    return add(result, invoicedType)
  }, '0.00')
  return invoicedBillingType
}

export const getExcludeVat = (billing = {}) => {
  const { billing_types = [] } = billing || {}
  const excludeVat = sumBy(billing_types, 'price')
  return excludeVat
}

export const getVat = (billing = {}) => {
  const { billing_types = [], vat = 0 } = billing || {}
  const excludeVat = sumBy(billing_types, 'price')
  const vatPrice = percentage(excludeVat, vat)
  return vatPrice
}

export const getIncludeVat = (billing = {}) => {
  const { billing_types = [], vat = 0 } = billing || {}
  const excludeVat = sumBy(billing_types, 'price')
  const vatPrice = percentage(excludeVat, vat)
  const includeVat = add(excludeVat, vatPrice)
  return includeVat
}

export const getBillingExcludeVat = (billings = []) => {
  const billingExcludeVat = sumBy(billings, b => getExcludeVat(b))
  return billingExcludeVat
}

export const getBillingVat = (billings = []) => {
  const billingExcludeVat = sumBy(billings, b => getVat(b))
  return billingExcludeVat
}

export const getBillingIncludeVat = (billings = []) => {
  const billingExcludeVat = sumBy(billings, b => getIncludeVat(b))
  return billingExcludeVat
}

export const getProjectRevenue = (project) => {
  const {
    $total_overall_contract_with_cr_price,
    $standard_total_overall_contract_with_cr_price,
  } = project
  return $total_overall_contract_with_cr_price ||
    $standard_total_overall_contract_with_cr_price || '0.00'
}

export const getProjectAvailable = (billings = [], projectRevenue) => {
  const billingExcludeVat = getBillingExcludeVat(billings)
  const projectAvailable = subtract(projectRevenue, billingExcludeVat)
  return projectAvailable
}

export const getProjectAvailableWhenModifyBilling = (projectAvailable, excludeVat) => {
  const projectAvailableWithBilling = subtract(projectAvailable, excludeVat)
  // const projectAvailableInBillingDetail = subtract(projectRevenue, projectAvailableWithBilling)
  return projectAvailableWithBilling
}

export const getProjectAvailableWhenEditBilling = (projectRevenue, excludeVat) => {
  const projectAvailableWithBilling = subtract(projectRevenue, excludeVat)
  // const projectAvailableInBillingDetail = subtract(projectRevenue, projectAvailableWithBilling)
  return projectAvailableWithBilling
}

export const getInterpretBillingType = (revenueAllocation = []) => {
  const interpretBillingType = revenueAllocation.map((a, i) => {
    const transformType = {
      label: billingType[a.type].label,
      value: billingType[a.type].value,
      cr_id: a.cr_id || '',
      product_id: a.product_id || '',
    }
    if (transformType.value !== 'SERVICE' && transformType.value !== 'CR') {
      transformType.label = `${transformType.label}/${a._product_name}`
    } else if (transformType.value === 'CR') {
      transformType.label = `${transformType.label}/${Numeral(i).format('00')}`
    }
    return transformType
  })
  return interpretBillingType
}

export const getAllocationByBillingType = (revenueAllocation = [], billingType = {}) => {
  const allocation = revenueAllocation.find(r => {
    if (r.type !== 'SERVICE' && r.type !== 'CR') {
      // Non-service
      return (r.type === billingType.type) && (r.product_id === billingType.product_id)
    }
    if (r.type === 'CR') {
      // CR
      return (r.type === billingType.type) && (r.cr_id === billingType.cr_id)
    }
    // service
    return (r.type === billingType.type)
  })
  return allocation
}



// WEBPACK FOOTER //
// ./src/function/billing.js